import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DialogComponent } from '../dialog/dialog.component';
import { ImportMappedProjectService } from 'src/app/Services/import-mapped-project.service';
import { NotifyService } from 'src/app/Services/notify.service';

@Component({
  selector: 'ze-selective-import',
  templateUrl: './selective-import.component.html',
  styleUrls: ['./selective-import.component.scss']
})
export class SelectiveImportComponent implements OnInit {

  projectId: string;
  mappedProject: any;
  isLoadingSelectiveData: boolean = false;
  isImporting: boolean = false;
  selectiveEpic: any[] = [];
  selectiveFeature: any[] = [];
  selectiveScenario: any[] = [];
  childList: any[] = [];
  selectedProject: any = "";
  MySelectedPayload = {
    licenseId: "",
    project: {} as any,
    epics: {
      epics: []
    },
    scenarios: {
      userStories: []
    }
  }
  constructor(
    public dialogRef: MatDialogRef<SelectiveImportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private importMappedProjectService: ImportMappedProjectService,
    private notifys: NotifyService,
    private cdr: ChangeDetectorRef
  ) {
    this.projectId = data.projectId;
    this.selectedProject = data.mappedProject;
    console.log('selected project', this.selectedProject);
  }

  ngOnInit() {
    this.toggleSelectiveImport();

    console.log('data', this.data);
  }

  toggleSelectiveImport() {
    if (this.data) {
      this.isLoadingSelectiveData = true;
      this.importMappedProjectService.updateProjectItems(this.projectId).subscribe(
        (response: any) => {
          this.isLoadingSelectiveData = false;
          this.selectiveEpic = (response && response.epics && response.epics.epics) || [];
          this.selectiveFeature = (response && response.features && response.features.features) || [];
          this.selectiveScenario = (response && response.scenarios && response.scenarios.userStories) || [];
        },
        (error) => {
          console.error('Error importing project:', error);
          this.isLoadingSelectiveData = false;
        }
      );
    }
  }

  onEpicCheckboxChange(event: any, epic: any) {
    if (event.target.checked) {
      const alreadyExists = this.MySelectedPayload.epics.epics.some(
        (e: any) => e.epic_id === epic.epic_id
      );

      if (!alreadyExists) {
        this.MySelectedPayload.epics.epics.push({
          epic_id: epic.epic_id,
          epic_key: epic.epic_key,
          epic_name: epic.epic_name,
          epicStatus: epic.epicStatus,
          project_management_type: epic.project_management_type,
          epic_created_time: epic.epic_created_time
        });
      }
      this.importMappedProjectService.childSelect(epic, this.selectedProject).subscribe(
        (response: any) => {
          const children = (
            response &&
            response.data &&
            response.data.scenarios &&
            response.data.scenarios.userStories
          ) || [];

          epic.children = children.map((child: any) => {
            child.selected = true;

            const alreadyChildExists = this.MySelectedPayload.scenarios.userStories.some(
              (s: any) => s.issue_id === child.issue_id
            );

            if (!alreadyChildExists) {
              this.MySelectedPayload.scenarios.userStories.push({
                issue_id: child.issue_id,
                issue_key: child.issue_key,
                issue_summary: child.issue_summary,
                issue_created_time: child.issue_created_time,
                project_management_type: child.project_management_type,
                issue_type: child.issue_type,
                project_management_project_id: child.project_management_project_id,
                projectName: child.projectName,
                status: child.status || '',
                parent_id: child.parent_id,
                parent_type: child.parent_type
              });
            }

            return child;
          });
        },(error)=>{
           console.log('opeartion msg ', error);
            // Show temporary warning
            epic.warningMessage = 'No child artifacts found';
            
            setTimeout(() => {
              epic.warningMessage = null;
            }, 2000); // 2 seconds
        }
      );
    } else {
      epic.selected = false;
      epic.children = [];

      this.MySelectedPayload.epics.epics = this.MySelectedPayload.epics.epics.filter(
        (e: any) => e.epic_id !== epic.epic_id
      );

      this.MySelectedPayload.scenarios.userStories = this.MySelectedPayload.scenarios.userStories.filter(
        (s: any) => s.parent_id !== epic.epic_id
      );
    }
  }

  onChildCheckboxChange(event: any, child: any) {
    if (event.target.checked) {
      child.selected = true;

      const alreadyExists = this.MySelectedPayload.scenarios.userStories.some(
        (s: any) => s.issue_id === child.issue_id
      );

      if (!alreadyExists) {
        this.MySelectedPayload.scenarios.userStories.push({
          issue_id: child.issue_id,
          issue_key: child.issue_key,
          issue_summary: child.issue_summary,
          issue_created_time: child.issue_created_time,
          project_management_type: child.project_management_type,
          issue_type: child.issue_type,
          project_management_project_id: child.project_management_project_id,
          projectName: child.projectName,
          status: child.status || '',
          parent_id: child.parent_id,
          parent_type: child.parent_type
        });
      }
    } else {
      child.selected = false;

      this.MySelectedPayload.scenarios.userStories = this.MySelectedPayload.scenarios.userStories.filter(
        (s: any) => s.issue_id !== child.issue_id
      );
    }
  }

  onFeatureCheckboxChange(event: any, feature: any) {
    if (event.target.checked) {
      this.importMappedProjectService.childSelectfeature(feature, this.selectedProject).subscribe(
        (response: any) => {
          feature.children = response.data.scenarios.userStories;
        })
    } else {
      feature.children = [];
    }
  }

  onScenarioCheckboxChange(event: any, scenario: any) {
    if (event.target.checked) {
      const alreadyExists = this.MySelectedPayload.scenarios.userStories.some(
        (s: any) => s.issue_id === scenario.issue_id
      );

      if (!alreadyExists) {
        this.MySelectedPayload.scenarios.userStories.push({
          issue_id: scenario.issue_id,
          issue_key: scenario.issue_key,
          issue_summary: scenario.issue_summary,
          issue_created_time: scenario.issue_created_time,
          project_management_type: scenario.project_management_type,
          issue_type: scenario.issue_type,
          project_management_project_id: scenario.project_management_project_id,
          projectName: scenario.projectName,
          status: scenario.status
        });
      }

      this.importMappedProjectService.childSelectscenario(scenario, this.selectedProject).subscribe(
        (response: any) => {
          scenario.children = response.data.scenarios.userStories;
        })
    } else {
      scenario.children = [];
      this.MySelectedPayload.scenarios.userStories = this.MySelectedPayload.scenarios.userStories.filter(
        (s: any) => s.issue_id !== scenario.issue_id
      );
    }
  }

  selectiveImport() {
     const storedLicenseId = localStorage.getItem('licenseId');
    // Treat explicit "null" or missing value as no license scenario
    const licenseId = storedLicenseId && storedLicenseId !== 'null' ? storedLicenseId : null;
    this.MySelectedPayload.licenseId = licenseId;
    this.MySelectedPayload.project = {
      project_id: this.projectId,
      project_management_project_id: this.selectedProject.project_management_project_id,
      projectName: this.selectedProject.projectName,
      project_management_project_key: this.selectedProject.project_management_project_key,
      projectTypeKey: this.selectedProject.projectTypeKey || 'software',
      todo: this.selectedProject.todo || 'To Do',
      inProgress: this.selectedProject.inProgress || 'In Progress',
      done: this.selectedProject.done || 'Done',
      codeReview: this.selectedProject.codeReview || 'CodeReview'
    };
    this.isImporting = true;
    this.importMappedProjectService.allSelectiveImport(this.MySelectedPayload).subscribe(
      (response: any) => {
        this.isImporting = false;

        // ✅ Close the popup
        this.dialogRef.close();
        this.notifys.notify('success', 'Success', "Save Successfully");
      },
      (error: any) => {
        this.isImporting = false;
        console.error('Import Error:', error);
      }
    );
  }

  onCancel() {
    // Close the dialog or reset logic
    this.dialogRef.close(); // if opened via MatDialog
  }
}
